import {
  getTgWebApp,
  supportsFullscreen,
  supportsSwipeBehaviour
} from "@/helpers/tgWebApp"
import { emulateDevTelegramUser } from "./emulateDevTelegramUser"

type TTgWebApp = NonNullable<ReturnType<typeof getTgWebApp>>

/**
 * The SDK posts `web_app_setup_swipe_behavior` only when asked and never
 * re-sends it, so every transition that may reset the gesture asks again.
 */
const reapplySwipeGuard = (tg: TTgWebApp) => {
  if (!supportsSwipeBehaviour(tg.version)) {
    return
  }

  tg.disableVerticalSwipes?.()
}

export const initTelegramData = () => {
  if (import.meta.env.VITE_NODE_ENV === "local") {
    emulateDevTelegramUser()
    return
  }

  const tg = getTgWebApp()
  if (!tg) {
    return
  }

  document.documentElement.setAttribute("data-platform", tg.platform)

  tg.ready?.()
  tg.expand?.()
  reapplySwipeGuard(tg)

  tg.onEvent?.("fullscreenChanged", () => reapplySwipeGuard(tg))
  tg.onEvent?.("activated", () => reapplySwipeGuard(tg))

  if (supportsFullscreen(tg.platform, tg.version)) {
    tg.requestFullscreen?.()
  }
}
